import {mfpAdminOrigin,mfpSmmOrigin} from '../../../environment/runtime';

const DB='mfk-pad-device-credentials-v1',KEY='device-token';
export function readPadDeviceId(){
  const key='mfk.admin-sync.device.v1';
  let value=localStorage.getItem(key);
  // Same existing installation identity used by Admin sync; it conveys no authority.
  if(!value){value='SMT-'+Array.from(crypto.getRandomValues(new Uint8Array(16)),b=>b.toString(16).padStart(2,'0')).join('');localStorage.setItem(key,JSON.stringify(value));}
  try{const parsed=JSON.parse(value);return typeof parsed==='string'?parsed:String(parsed.deviceId||value);}catch{return value;}
}
let tokenCache:string|undefined;
let required=true;
const listeners=new Set<()=>void>();
export const subscribePadRegistration=(fn:()=>void)=>{listeners.add(fn);return()=>{listeners.delete(fn);};};
export const padRegistrationRequired=()=>required;
function registrationState(value:boolean){if(required===value)return;required=value;for(const fn of listeners)fn();}
async function credentialStore(mode:IDBTransactionMode,value?:string):Promise<string>{
  if(typeof indexedDB==='undefined'){if(mode==='readwrite')throw Error('PAD_CREDENTIAL_STORAGE_UNAVAILABLE');return '';}
  return new Promise((resolve,reject)=>{
    const open=indexedDB.open(DB,1);
    open.onupgradeneeded=()=>open.result.createObjectStore('credentials');
    open.onerror=()=>reject(Error('PAD_CREDENTIAL_STORAGE_UNAVAILABLE'));
    open.onsuccess=()=>{
      const db=open.result,transaction=db.transaction('credentials',mode),store=transaction.objectStore('credentials');
      let result='';
      const request=mode==='readwrite'?store.put(value,KEY):store.get(KEY);
      request.onsuccess=()=>{result=mode==='readwrite'?value||'':String(request.result||'');};
      transaction.oncomplete=()=>{db.close();resolve(result);};
      transaction.onerror=()=>{db.close();reject(Error('PAD_CREDENTIAL_STORAGE_UNAVAILABLE'));};
      transaction.onabort=()=>{db.close();reject(Error('PAD_CREDENTIAL_STORAGE_UNAVAILABLE'));};
    };
  });
}
export async function readPadDeviceToken(){
  if(tokenCache!==undefined)return tokenCache;
  try{tokenCache=await credentialStore('readonly');}catch{tokenCache='';}
  registrationState(!tokenCache);
  return tokenCache;
}
export async function registerPadDevice(code:string,deviceId:string){
  if(!/^[0-9a-f]{64}$/.test(code.trim()))throw Error('登記碼格式不正確');
  const response=await globalThis.fetch(mfpAdminOrigin()+'/api/admin-sync/devices/redeem?storeId=MF01',{
    method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({code:code.trim(),deviceId}),
  });
  const body=await response.json().catch(()=>null);
  if(!response.ok||!/^[0-9a-f]{64}$/.test(body?.deviceToken||'')||body.deviceId!==deviceId)throw Error('登記未完成，請在 Admin 重新產生登記碼');
  await credentialStore('readwrite',body.deviceToken);
  tokenCache=body.deviceToken;registrationState(false);
  if(typeof window!=='undefined')window.dispatchEvent(new Event('mfk-pad-registered'));
}
/** Scoped transport: credential is sent only to the Admin service, never arbitrary URLs. */
export function padDeviceFetch(input:RequestInfo|URL,init?:RequestInit):Promise<Response>{
  const raw=input instanceof Request?input.url:String(input);
  const admin=new URL(mfpAdminOrigin()),url=new URL(raw,typeof location==='undefined'?admin.origin:location.href);
  const protectedPath=/^\/api\/(admin-sync|projection|pos|customer\/smt|keeta\/smt)\//.test(url.pathname);
  const mobilePath=url.origin===new URL(mfpSmmOrigin()).origin&&url.pathname.startsWith('/api/smm/');
  const localProxy=typeof location!=='undefined'&&url.origin===location.origin&&/^\/__mfk\/(admin\/api\/admin-sync\/|smm-acceptance\/|smm-fulfillment\/)/.test(url.pathname);
  if(!(url.origin===admin.origin&&protectedPath)&&!mobilePath&&!localProxy)return globalThis.fetch(input,init);
  const headers=new Headers(init?.headers||(input instanceof Request?input.headers:undefined));
  const send=(token:string)=>{
    if(token)headers.set('x-mfk-pad-token',token);
    return globalThis.fetch(input,{...init,headers}).then(response=>{
      if(response.status===401)registrationState(true);
      else if(response.ok&&token)registrationState(false);
      return response;
    }).catch(error=>{registrationState(true);throw error;});
  };
  if(tokenCache!==undefined||typeof indexedDB==='undefined')return send(tokenCache||'');
  return readPadDeviceToken().then(send);
}
